export const openPdf = (blob: Blob) => {
  const url = window.URL.createObjectURL(blob.slice(0, blob.size, 'application/pdf'));
  window.open(url, '_blank');
  window.URL.revokeObjectURL(url);
};

export const openImage = (blob: Blob, contentType = 'application/octet-stream') => {
  const url = window.URL.createObjectURL(blob.slice(0, blob.size, contentType));
  window.open(url, '_blank');
  window.URL.revokeObjectURL(url);
};
